import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  class: "GeotargetingModal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainContent = _resolveComponent("MainContent")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_MainContent)
  ], 512 /* NEED_PATCH */))
}